import React from 'react';
import { useEvent } from '@rc-component/util';
import { clsx } from 'clsx';
const InternalExpandIcon = (props) => {
    const { prefixCls, type, expanded, expandable, onClick, locale } = props;
    const iconPrefix = `${prefixCls}-row-expand-icon`;
    if (type === 'all' && !expandable) {
        return React.createElement("span", { className: clsx(iconPrefix, `${iconPrefix}-spaced`) });
    }
    const ariaLabel = type === 'all'
        ? expanded
            ? locale.collapseAll
            : locale.expandAll
        : expanded
            ? locale.collapse
            : locale.expand;
    return (React.createElement("button", { type: "button", onClick: onClick, className: clsx(iconPrefix, {
            [`${iconPrefix}-spaced`]: !expandable,
            [`${iconPrefix}-expanded`]: expandable && expanded,
            [`${iconPrefix}-collapsed`]: expandable && !expanded,
        }), "aria-label": ariaLabel, "aria-expanded": expanded }));
};
export default function useExpandIcon(locale, ExpandIcon, ...legacyRenderExpandIcon) {
    const MergedExpandIcon = useEvent((props) => {
        if (ExpandIcon) {
            return React.createElement(ExpandIcon, { ...props });
        }
        for (const renderExpandIcon of legacyRenderExpandIcon) {
            if (renderExpandIcon) {
                if (props.type === 'row') {
                    const { prefixCls, record, expanded, expandable, onClick } = props;
                    return renderExpandIcon({
                        prefixCls,
                        record,
                        expanded,
                        expandable,
                        onExpand: (_record, event) => onClick(event),
                    });
                }
                return React.createElement(InternalExpandIcon, { ...props, locale: locale });
            }
        }
        return React.createElement(InternalExpandIcon, { ...props, locale: locale });
    });
    return MergedExpandIcon;
}
